import { createContext, useContext } from "react";
import tr from "@/content/tr";
import sl from "@/content/sl";

export const LANGS = ["tr", "sl"];
export const CONTENT = { tr, sl };

export const ROUTES = {
  tr: {
    home: "", moving: "/slovenyaya-tasinma", living: "/slovenyada-yasam", about: "/hakkimda",
    services: "/hizmetler", business: "/kurumsal", contact: "/iletisim", apply: "/basvuru",
    thanks: "/tesekkurler", privacy: "/gizlilik", cookies: "/cerezler",
  },
  sl: {
    home: "", moving: "/selitev-v-slovenijo", living: "/zivljenje-v-sloveniji", about: "/o-meni",
    services: "/storitve", business: "/za-podjetja", contact: "/kontakt", apply: "/prijava",
    thanks: "/hvala", privacy: "/zasebnost", cookies: "/piskotki",
  },
};

export const pathFor = (lang, key) => `/${lang}${ROUTES[lang]?.[key] ?? ""}`;

export const PageCtx = createContext({ lang: "tr", page: "home" });
export const usePage = () => useContext(PageCtx);
export const useT = () => CONTENT[usePage().lang];
export const useLink = () => {
  const { lang } = usePage();
  return (key) => pathFor(lang, key);
};

export const CONTACT = {
  email: "info@homeinslovenia.org",
  phone: "+386 71 232 972",
  phoneHref: "tel:+38671232972",
  whatsappHref: "https://wa.me/38671232972",
  instagram: "@home.in.slovenia",
  instagramHref: "https://www.instagram.com/home.in.slovenia/",
  website: "homeinslovenia.org",
};
